module.exports = __webpack_public_path__ + "static/img/item_back_bg_green.3eca65b4.svg";